import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const initialState = {
  userId: 0,
  username: "",
  email: "",
  password: "", 
};

const UserForm = ({ onSave, initialData,loading,setLoading }) => {
  const [user, setUser] = useState(initialState);

  useEffect(() => {
    if (initialData) {
      setUser({ ...initialData });
    } else {
      setUser(initialState);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    onSave(user);
    setTimeout(() =>{
      setLoading(false);
    },2000)
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="username">
            <Form.Label>
              UserName <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={user.username}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="email">
            <Form.Label>
              Email <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={user.email}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        {!initialData && (
          <Col md={12}>
            <Form.Group controlId="password">
              <Form.Label>
                Password <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={user.password}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        )}
      </Row>

      <Row>
        <Col>
          <div className="form-buttons">
            <Button type="submit" className="me-2"
            disabled={loading}>
             {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
            </Button>
            <Button variant="secondary" onClick={() => setUser(initialState)}>
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default UserForm;
